import Vue from 'vue'
// import Router from 'vue-router'
import VueRouter from 'vue-router'
import { createRouter, createWebHistory } from "vue-router";
import Login from '../Routerpages/Login.vue'
import Dashboard from '../Routerpages/Dashboard.vue'
// import DashboardTwo from '../Routerpages/DashboardTwo.vue'
import LandingPage from '../Routerpages/LandingPage.vue'
// import Homepage from '../Routerpages/Homepage.vue';
// import Frame from '../Routerpages/Frame.vue';
import store from '../store/index.js'; // Import the store
// import { RouterTabRoutes } from 'vue-router-tab'
// import { Children } from 'react';



// const importPage = view => () =>
//   import(/* webpackChunkName: "p-[request]" */ `./views/${view}.vue`)
localStorage.clear();
Vue.use(VueRouter)
// Vue.use(Router)
const routes = [
    // {
    //     path: '/',
    //     name: 'Home',
    //     component: Home,
    //   },
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false },
      
    },
    {
      path: '/index.html',
      // redirect: '/',
      alias: '/',
      name: 'index',
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: LandingPage,
      meta: { requiresAuth: false},
    //   props: {}
    },
    {
      path: '/ptrc',
      name: 'ICI subtype study (Chowhury et. al.)',
      component: Dashboard,
      meta: { requiresAuth: false },
      beforeEnter: (to, from, next) => {
        if (!to.meta.requiresAuth) {
          next();
          // console.log('router js back to home login')
          // next({ path: '/' });
        } else {
          if (isAuthenticated()) {
            next();
          } else {
            next({ path: '/', name: 'login'});
          }
          // console.log('router js to', to)
          // next();
        }
      }
    //   props: {}
    },
    {
      path: '/pcc',
      name: 'Deep profiling study (Gong et. al.)',
      component: Dashboard,
      meta: { requiresAuth: false },
      // beforeEnter: (to, from, next) => {
      // }
    //   props: {}
    },

    // {
    //     path: '*',
    //     name: 'NotFound',
    //     component: NotFound,
    // },
  ]

const router = new VueRouter({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes: routes,
    // history: createWebHistory(),
})


// Mock authentication functions
function isAuthenticated() {
    // Replace this with your actual authentication logic
    return Boolean(store.state.login_state);
}

// function isAdmin() {
// // Replace this with your actual role-checking logic
// return localStorage.getItem('role') === 'admin';
// }

console.log('router js all routes', router.options.routes);

router.beforeEach((to, from, next) => {
    console.log('router js from', from)
    console.log('router js to', to)
    console.log('router js to.meta.requiresAuth', to.meta.requiresAuth)
    console.log('router js loginstate', isAuthenticated())
    console.log('router js condition1', (to.meta.requiresAuth && !isAuthenticated()))
    console.log('router js condition1.1', to.meta.requiresAuth)
    console.log('router js condition1.2', (!isAuthenticated()))
    // if (to.meta.requiresAuth && !isAuthenticated()) {
    //   console.log('router js back to home login')
    //   next({ path: '/' });
    // } else if (!to.meta.requiresAuth || isAuthenticated())  {
    //   console.log('router js to', to)
    //   next();
    // }

    if (!to.meta.requiresAuth) {
      next();
      // console.log('router js back to home login')
      // next({ path: '/' });
    } else {
      if (isAuthenticated()) {
        next();
      } else {
        next({ path: '/', name: 'login'});
      }
      // console.log('router js to', to)
      // next();
    }
  });

// const router = createRouter({
//     history: createWebHistory(process.env.BASE_URL),
//     routes,
// });
// const router = new VueRouter({
//  mode: 'history'
// })
export default router;